import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import AsyncSelect from 'react-select/async';

import Const from '../../util/Constants';

class FieldCountry extends React.Component {
  
  constructor(props) {
    super(props);
    this.countries = reactLocalStorage.getObject(Const.Countries);
  }

  onSearch = (text, callback) => {
    let countries = [];
    if(text.length > 2) {
      countries = this.countries.filter(country =>
        country.label.replace(' ', '').toLowerCase().includes(text.replace(' ', '').toLowerCase()));
    }
    callback(countries);
  }

  render() {
    return (
      <AsyncSelect cacheOptions isMulti={this.props.isMulti}
        isClearable={true} loadOptions={this.onSearch}
        onChange={selected => this.props.onSelected(selected, this.props.index)}
        value={this.props.defaultValue} />
    );
  }

  static getCountryById = countryId => {
    return reactLocalStorage.getObject(Const.Countries).find(
      country => parseInt(country.value) === parseInt(countryId));
  }
}
export default FieldCountry;